import angular from 'angular';

angular.module('cloudX').filter('invoiceStreamName', ['$translate', invoiceStreamName]);

function invoiceStreamName($translate) {
  return function(stream, defaultName, ignoreCustomName = false) {
    if (!stream || typeof stream.assignmentId === 'undefined') return '';
    if (!stream.assignmentId)
      return typeof defaultName !== 'undefined'
        ? defaultName
        : $translate.instant('Default assignment');
    if (!stream.assignmentTemplateId) return stream.assignmentName;

    if (!ignoreCustomName && !!stream.assignmentName) return stream.assignmentName;
    const key = `assignmenttemplate_${stream.assignmentTemplateId}`;
    const translation = $translate.instant(key, null, null, null, 'escaped');
    return (
      (!translation || key === translation ? null : translation) ||
      stream.assignmentTemplateName ||
      stream.assignmentName
    );
  };
}
